const PRE_NOTICE_ACCESSORIAL_TYPES = [
  'peel_pile',
  'redelivery',
  'repack',
  'destination_delivery_port_waiting_time',
  'yard_storage',
  'port_congestion',
  'destination_delivery_chassis_rental',
  'destination_cfs_storage_charges',
  'highway_toll',
  'palletization_destination',
];

export { PRE_NOTICE_ACCESSORIAL_TYPES };
